import Dx from './Template'

export default Dx
